import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { ConfirmButton } from 'components/common';

const UsersDisableTwoFactorAuth = connect((state) => ({
  messages: state.messages
}))(
  class extends Component {
    disable = async () => {
      const { targetUser, updateUsers } = this.props;

      const response = await api.put(`/admin/users/${targetUser.id}`, {
        totpKey: null,
        totpBackupCodes: null
      });
      if (!response.data || !response.data.success) return false;
      await updateUsers({ showLoading: false });
      return true;
    };

    render() {
      const { messages, targetUser } = this.props;

      if (!targetUser?.twoFactorAuthIsEnabled) return null;

      return (
        <ConfirmButton
          actionText={messages.commonDisable}
          buttonIcon="key"
          buttonIsDropdown={true}
          buttonText={messages.authTwoFactorDisable}
          category="danger"
          confirmText={messages.usersDisableTwoFactorAuthenticationConfirm}
          confirmTitle={messages.authTwoFactorDisable}
          onConfirm={this.disable}
          successMessage={messages.usersDisableTwoFactorAuthenticationSuccess}
        />
      );
    }
  }
);

export default UsersDisableTwoFactorAuth;
